import { useTranslation } from "react-i18next"
import { CustomInputGroups } from "types"
import useLayout from "hooks/useLayout"
import Form from "components/forms/form"
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg"
import { ReactComponent as CloseIcon } from "assets/icons/close.svg"
import Button from "components/inputs/button"
import ButtonGroup from "components/buttons/buttonGroup"
import Section from "components/layout/section"
import { Dispatch, SetStateAction, useCallback } from "react"

interface DeleteCustomInputGroupFormProps {
    setGroups: Dispatch<SetStateAction<CustomInputGroups>>
    setCustomInputGroupOrder: Dispatch<SetStateAction<string[]>>
    groups: CustomInputGroups
    groupName: string
}

const DeleteCustomInputGroupForm: React.FC<DeleteCustomInputGroupFormProps> = ({ setGroups, groups, setCustomInputGroupOrder, groupName }) => {

    const { t } = useTranslation()

    const { closeDialog } = useLayout()

    // Handle form submission with enhanced logic
    const handleSubmit = useCallback(() => {
        // Remove the group.
        let newGroups = { ...groups }
        delete newGroups[groupName]
        setGroups(newGroups)
        // Remove the group from the order.
        setCustomInputGroupOrder(order => {
            return order.filter(o => o !== groupName)
        })
        // Close the dialog.
        closeDialog()
    }, [groups, groupName, setGroups, setCustomInputGroupOrder, closeDialog])

    // Handle keydown event for Enter key
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            handleSubmit()
        }
    }

    // Return the JSX.
    return (
        <div
            className={`group`}
            onKeyDown={handleKeyDown}>
            <Section>
            <ButtonGroup>
                <Button wideOnMobile type="button" design="white" onClick={closeDialog}><CloseIcon /><span>{t('buttonCancel')}</span></Button>
                <Button wideOnMobile type="button" design="danger" onClick={handleSubmit}><DeleteIcon /><span>{t('buttonDelete')}</span></Button>
            </ButtonGroup>
            </Section>
        </div>
    )

}

export default DeleteCustomInputGroupForm



